import { toJpeg, toPng, toSvg } from "html-to-image";
import { jsPDF } from "jspdf";

export const htmlToJpegConvert = async (
  elementRef,
  orientation,
  download = false,
  highlightArea
) =>
  new Promise((resolve, reject) => {
    elementRef.style.transform = "scale(1)";
    // setIsLoading(true);
    setTimeout(() => {
      toJpeg(elementRef, {
        cacheBust: false,
        pixelRatio: 8,
        width: highlightArea.offsetWidth,
        height: highlightArea.offsetHeight,
        style: {
          position: "relative",
          transform: `translate(-${highlightArea.offsetLeft}px, -${highlightArea.offsetTop}px)`,
        },
      })
        .then(async (dataUrl) => {
          if (download) {
            const link = document.createElement("a");
            link.download = "map.jpg";
            link.href = dataUrl;
            link.click();
          }

          setTimeout(() => {
            elementRef.style.transform = "";
            // setIsLoading(false);
            resolve(dataUrl);
          });
        })
        .catch((err) => {
          // setIsLoading(false);
          reject(err);
        });
    });
  });

export const htmlToPngConvert = async (
  elementRef,
  orientation,
  download = false,
  highlightArea
) =>
  new Promise((resolve, reject) => {
    elementRef.style.transform = "scale(1)";
    // setIsLoading(true);
    setTimeout(() => {
      toPng(elementRef, {
        cacheBust: false,
        pixelRatio: 8,
        width: highlightArea.offsetWidth,
        height: highlightArea.offsetHeight,
        style: {
          position: "relative",
          transform: `translate(-${highlightArea.offsetLeft}px, -${highlightArea.offsetTop}px)`,
        },
      })
        .then(async (dataUrl) => {
          if (download) {
            console.log("entered....");
            const link = document.createElement("a");
            link.download = "map.png";
            link.href = dataUrl;
            link.click();
          }

          setTimeout(() => {
            elementRef.style.transform = "";
            // setIsLoading(false);
            resolve(dataUrl);
          });
        })
        .catch((err) => {
          // setIsLoading(false);
          reject(err);
        });
    });
  });

export const htmlToPdfConvert = async (
  elementRef,
  orientation,
  // setIsLoading,
  download = false,
  highlightArea
) =>
  new Promise((resolve, reject) => {
    elementRef.style.transform = "scale(1)";
    // setIsLoading(true);
    setTimeout(() => {
      toPng(elementRef, {
        cacheBust: false,
        pixelRatio: 8,
        width: highlightArea.offsetWidth,
        height: highlightArea.offsetHeight,
        style: {
          position: "relative",
          transform: `translate(-${highlightArea.offsetLeft}px, -${highlightArea.offsetTop}px)`,
        },
      })
        .then(async (dataUrl) => {
          const pdf = new jsPDF({
            orientation,
            unit: "px",
            format: [highlightArea.offsetWidth, highlightArea.offsetHeight],
          });
          // const imgProps = pdf.getImageProperties(dataUrl);
          // const pdfWidth = pdf.internal.pageSize.getWidth();
          // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(
            dataUrl,
            "PNG",
            0,
            0,
            highlightArea.offsetWidth,
            highlightArea.offsetHeight
          );
          pdf.save("map.pdf");

          setTimeout(() => {
            elementRef.style.transform = "";
            // setIsLoading(false);
            resolve(dataUrl);
          });
        })
        .catch((err) => {
          // setIsLoading(false);
          reject(err);
        });
    });
  });

export const htmlToSvgConvert = async (
  elementRef,
  orientation,
  download = false,
  highlightArea
) =>
  new Promise((resolve, reject) => {
    elementRef.style.transform = "scale(1)";
    // setIsLoading(true);
    setTimeout(() => {
      toSvg(elementRef, {
        cacheBust: false,
        pixelRatio: 8,
        width: highlightArea.offsetWidth,
        height: highlightArea.offsetHeight,
        style: {
          position: "relative",
          transform: `translate(-${highlightArea.offsetLeft}px, -${highlightArea.offsetTop}px)`,
        },
      })
        .then(async (dataUrl) => {
          if (download) {
            const link = document.createElement("a");
            link.download = "map.svg";
            link.href = dataUrl;
            link.click();
          }

          setTimeout(() => {
            elementRef.style.transform = "";
            // setIsLoading(false);
            resolve(dataUrl);
          });
        })
        .catch((err) => {
          // setIsLoading(false);
          reject(err);
        });
    });
  });
